import { render, staticRenderFns } from "./SalesChart.vue?vue&type=template&id=0ed84170&scoped=true&"
import script from "./SalesChart.vue?vue&type=script&lang=js&"
export * from "./SalesChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesChart.vue?vue&type=style&index=0&id=0ed84170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed84170",
  null
  
)

export default component.exports